export const getHelpCenterLink = (locale: string, customer_id: string) => {
  if (locale.includes('en')) {
    return `https://support-us.finn.com/hc/en-us`;
  }

  return `https://support.finn.com/hc/de-de${
    customer_id ? `?customer_id=${customer_id}` : ''
  }`;
};
